var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-2"},[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v("经销商数量(按博世壁挂炉采购贡献划分)")]),_c('v-card-text',[(_vm.data.length)?_c('v-chart',{staticStyle:{"height":"250px"},attrs:{"autoresize":"","option":_vm.option}}):_c('p',[_vm._v("没有数据！")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }